import { createReducer, on } from '@ngrx/store';
import * as ShippingActions from './shipping.actions';

export interface ShippingState {
  kmDistance: string;
  shippingCost: string;
  mountForDelivery: string;
  deliveryPercent: string;
  totalCost: string;
  time: string;
  deliveryTip: string;
  phone: string;
  tarifaBase: string;
  tarifaServicio: string;
}

export const initialState: ShippingState = {
  kmDistance: '0',
  shippingCost: '0',
  mountForDelivery: '0',
  deliveryPercent: '0',
  totalCost: '0',
  time: '0',
  deliveryTip: '0',
  phone: '',
  tarifaBase: '0',
  tarifaServicio: '0',
};

export const shippingReducer = createReducer(
  initialState,
  on(ShippingActions.SetDistanceKm, (state, { distanceKm }) => ({
    ...state,
    kmDistance: distanceKm
  })),
  on(ShippingActions.setShippingCost, (state, { cost }) => ({
    ...state,
    shippingCost: cost
  })),
  on(ShippingActions.setMountForDelivery, (state, { mount }) => ({
    ...state,
    mountForDelivery: mount
  })),
  on(ShippingActions.setDeliveryPercent, (state, { percent }) => ({
    ...state,
    deliveryPercent: percent
  })),
  on(ShippingActions.setTotalCost, (state, { totalCost }) => ({
    ...state,
    totalCost: totalCost
  })),
  on(ShippingActions.setTime, (state, { time }) => ({
    ...state,
    time: time
  })),
  on(ShippingActions.setDeliveryTip, (state, { tip }) => ({
    ...state,
    deliveryTip: tip
  })),
  on(ShippingActions.setPhoneEstablishment, (state, { phone }) => ({
   ...state,
    phone: phone
  })),
  on(ShippingActions.resetShipping, () => initialState),
  on(ShippingActions.setTarifaBase, (state, { tarifaBase }) => ({
    ...state,
    tarifaBase: tarifaBase
  })),
  on(ShippingActions.setTarifaServicio, (state, { tarifaServicio }) => ({
    ...state,
    tarifaServicio: tarifaServicio
  })),

);
